import React from 'react';

import { createClassName } from 'utils/createClassName';

import './modalLayerStyles.scss';

type Props = {
  theme: 'transparent' | 'dark';
};

export const ModalLayerComponent: React.FC<Props> = (props) => {
  const { children, theme } = props;

  const createModalLayerClassName = createClassName('modalLayer');

  const wrapperClassName = createModalLayerClassName('wrapper', { theme });

  const contentClassName = createModalLayerClassName('content', { theme });

  return (
    <div className={wrapperClassName}>
      <div className={contentClassName}>{children}</div>
    </div>
  );
};
